export const edit = 'edit';
export const fill = 'fill';
export const readonly = 'readonly';
export const pdf = 'pdf';

export default {
  edit,
  fill,
  readonly,
  pdf
};
